import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { BaseClass } from '../../models/base-class';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { TaskService } from '../../services/rest/task.service';
import { LanguageService } from '../../services/common/language.service';
import { debounceTime, filter, switchMap, take, tap } from 'rxjs/operators';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as moment from 'moment';
import { prioritys } from '../../consts/prioritys';
import { fromEvent, ReplaySubject, Subscription } from 'rxjs';
import { GlobalDataService } from '../../services/common/global-data.service';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from 'src/app/components/workspace-pages/cases/dialogs/open-task/dialogs/channels-table/channels-table.component';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Moment } from 'moment';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
  selector: 'app-active-filters',
  templateUrl: './active-filters.component.html',
  styleUrls: ['./active-filters.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})

export class ActiveFiltersComponent extends BaseClass implements OnInit, OnDestroy {
  @Input() company_id: any;
  @Input() filter: any;
  @Input() filterValue: any;
  @Input() section: string = '';
  @Output() RemoveValue = new EventEmitter<any>();
  @Output() RemoveValueFromMultiple = new EventEmitter<any>();
  @ViewChild('filMenu') filMenu: TemplateRef<any>;

  public currMonthName: any;
  public activeLang: any;

  throttle = 300;
  scrollUpDistance = 3.5;

  public taskStatuses: any;
  public taskStatuses$: ReplaySubject<any> = new ReplaySubject<any>(1);

  public employees: any = [];
  public employees$: ReplaySubject<any> = new ReplaySubject<any>(1);

  public prioritys = prioritys;


  public searchFil: FormControl = new FormControl('')

  public allContentTypes: any;
  public contentTypes: any[] = [];
  public contentTypesControl: FormControl = new FormControl();
  public contentTypes$: ReplaySubject<any> = new ReplaySubject<any>(1);

  public clients: any;
  public viewsUpdateIntervalList: any;

  public parameters: any;
  
  public partners: any;
  public partners$: ReplaySubject<any> = new ReplaySubject<any>(1);
  
  public allValues: any;
  public allValues$: ReplaySubject<any> = new ReplaySubject<any>(1);
  
  public statuses: any;
  public checklists: any;
  
  public jobTypes: any; 
  public jobTypes$: ReplaySubject<any> = new ReplaySubject<any>(1);

  public partnerGroups: any;
  public partnerGroups$: ReplaySubject<any> = new ReplaySubject<any>(1);
  
  public groups: any; 
  public groups$: ReplaySubject<any> = new ReplaySubject<any>(1);

  public platforms: any;
  public platforms$: ReplaySubject<any> = new ReplaySubject<any>(1);
  
  public profiles: any;
  public profiles$: ReplaySubject<any> = new ReplaySubject<any>(1);

  public profileStatuses: any; 
  public contentUrl: any = [
    {
      name: marker("Without content url"),
      id: 0
    },
    {
      name: marker("With content url"),
      id: 1
    }
  ]

  public key: string = ''

  public employeesSub: Subscription;
  public sub: Subscription;
  overlayRef: OverlayRef | null;

  constructor(
    private languageService: LanguageService,
    private taskService: TaskService,
    public overlay: Overlay,
    public viewContainerRef: ViewContainerRef,
    public activatedRoute: ActivatedRoute, 
    private router: Router,
    private globalDataService: GlobalDataService,
    private _adapter: DateAdapter<any>,
  ) { 
    super() 
  }

  ngOnInit(): void {
    console.log('ActiveFiltersComponent onINIT filter', this.filter);
    this.getLangData();
    this.attachSubscriptions(
      this.globalDataService.getTransferData().subscribe(resp => {
        // console.log("ActiveFiltersComponent getTransferData", resp)

        if (resp.allContentTypes) {
          this.allContentTypes = resp.allContentTypes;

          let arr = [];

          resp.allContentTypes.forEach(el => {
            if (arr.filter(x => x.channel_platform_id == el.channel_platform_id).length == 0) {
              arr.push({
                channel_platform_id: el.channel_platform_id,
                types: [el]
              })
            } else {
              arr.find(x => x.channel_platform_id == el.channel_platform_id).types.push(el)
            }
          })
  
          this.contentTypes = arr;
          this.contentTypes$.next(this.copyContentTypesGroups(this.contentTypes));
        }
        if (resp.employees) {
          this.employees = resp.employees;
          this.employees$.next(this.employees.slice())
        }
        if (resp.clients) {
          this.clients = resp.clients;
        }
        if (resp.viewsUpdateIntervalList) {
          this.viewsUpdateIntervalList = resp.viewsUpdateIntervalList;
        }
        if (resp.partners) {
          this.partners = resp.partners;
          this.partners$.next(this.partners.slice())
        }
        if (resp.allValues) {
          this.allValues = resp.allValues;
          this.allValues$.next(this.allValues.slice())
        }
        if (resp.statuses) {
          this.statuses = resp.statuses;
        }
        if (resp.checklists) {
          this.checklists = resp.checklists;
        }
        if (resp.taskStatuses) {
          this.taskStatuses = resp.taskStatuses;
          this.taskStatuses$.next(this.taskStatuses.slice())
        }
        if (resp.jobTypes) {
          this.jobTypes = resp.jobTypes;
          this.jobTypes$.next(this.jobTypes.slice())
        }
        if (resp.parameters) {
          this.parameters = resp.parameters;
          // getParameterById
        }
        if (resp.partnerGroups) {
          this.partnerGroups = resp.partnerGroups;
          this.partnerGroups$.next(this.partnerGroups.slice())
        }
        if (resp.groups) {
          this.groups = resp.groups;
          this.groups$.next(this.groups.slice())
        }
        if (resp.prioritys) {
          this.prioritys = resp.prioritys;
        }
        if (resp.platforms) {
          this.platforms = resp.platforms;
          this.platforms$.next(this.platforms.slice())
        }
        if (resp.profiles) {
          this.profiles = resp.profiles;
          this.profiles$.next(this.profiles.slice())
        }
        if (resp.profileStatuses) {
          this.profileStatuses = resp.profileStatuses;
        }
        if (resp.contentUrl) {
          this.contentUrl = resp.contentUrl;
        }
      })
    )

    this.attachSubscriptions(
      this.searchFil.valueChanges.pipe(debounceTime(300)).subscribe((resp) => this.onSearchFilter(resp, this.key))
    )
  }

  getParameterById(id) {
    if (!this.parameters || this.parameters.length == 0) {
      return null
    }
    return this.parameters.find(x => x.id == id)
  }

  getChecklist(id) {
    if (!this.checklists || !this.checklists.find(el => el.id == id)) {
      return false;
    }
    return this.checklists.find(el => el.id == id)
  }  

  getStatus(id) {
    if (!this.statuses) {
      return false;
    }
    return this.statuses.find(el => el.id == id)
  }  
  
  getViewsUpdateIntervalListByValue(val) {
    if (!this.viewsUpdateIntervalList || this.viewsUpdateIntervalList.length == 0) {
      return null
    }
    return this.viewsUpdateIntervalList.find(x => x.value == val)
  }
  
  // ngOnChanges(changes: SimpleChanges): void {
  //   console.log('ActiveFiltersComponent changes', changes)
  //   // if (changes.filterValue && changes.filterValue.currentValue && changes.filterValue.currentValue.operation_employee_id && changes.filterValue.currentValue.operation_employee_id.length) {
  //   //   this.employeesSub = this
  //   // }
  // }

  onDown(e, control) {
    this.globalDataService.onDown$.next({e, control})
  }

  setFilValue(e, key, val) {
    // console.log('e', e)
    // console.log('e.target', e.target.nodeName == 'MAT-PSEUDO-CHECKBOX')
    // console.log('key', key)
    // console.log('val', val)
    if (e.target.nodeName != 'MAT-PSEUDO-CHECKBOX') {
      e.preventDefault();
      e.stopPropagation();
      this.filter.patchValue({
        [key]: [val]
      })
      // this.searchFilterSubmit();

      let currentParams = { ...this.activatedRoute.snapshot.queryParams };

      if (key && key == 'task_operation_operation_id') { 
        currentParams['no_operation_id'] = this.filter.value.no_operation_id;
      }

      currentParams[key] = this.filter.get(key).value.join(',');
      this.router.navigate([], { queryParams: currentParams });
      this.closeFil();
    }
  }

  startSearch(key) {
    let currentParams = { ...this.activatedRoute.snapshot.queryParams };
    currentParams[key] = this.filter.get(key).value.join(',');
    if (!currentParams[key].length) {
      delete currentParams[key]
    }
    if (!!key) {
      if (key == 'no_operation_id') {
        currentParams['task_operation_operation_id'] = this.filter.value.task_operation_operation_id;
      }
      if (key == 'task_operation_operation_id') {
        currentParams['no_operation_id'] = this.filter.value.no_operation_id;
      }
    }
    this.router.navigate([], { queryParams: currentParams });
    this.closeFil();
  }
  
  getGroup(id) {
    if (!this.groups || !this.groups.find(el => el.id == id)) {
      return false;
    }
    return this.groups.find(el => el.id == id)
  }  

  getPartnerGroup(id) {
    if (!this.partnerGroups || !this.partnerGroups.find(el => el.id == id)) {
      return false;
    }
    return this.partnerGroups.find(el => el.id == id)
  }  

  getOperationStatusName(id) {
    switch (+id) {
      case 1:
        return "Waiting";
        break;
      case 2:
        return "In process";
        break;
      case 3:
        return "To approve";
        break;
      case 4:
        return "Approved";
        break;
      case 5:
        return "To correct";
        break;
      case 6:
        return "Sources Needed";
        break;
      case 97:
        return "On hold";
        break;
      case 98:
        return "Ready";
        break;
      case 99:
        return "Canceled";
        break;
    }
  }

  getFilterOperationStatusName(id) {
    if (typeof id == "object") {

      if (id.sort().toString() == '1,2,5') {
        return 'All to do'
      } else if (id.sort().toString() == '3,4,6,97,98,99') {
        return 'All done'
      } else {
        let text = []
        id.forEach(x => {
          text.push(this.getOperationStatusName(x))
        })
        return text.join(", ")
      }
    } else {
      switch (+id) {
        case 1:
          return "Waiting";
          break;
        case 2:
          return "In process";
          break;
        case 3:
          return "To approve";
          break;
        case 4:
          return "Approved";
          break;
        case 5:
          return "To correct";
          break;
        case 6:
          return "Sources Needed";
          break;
        case 97:
          return "On hold";
          break;
        case 98:
          return "Ready";
          break;
        case 99:
          return "Canceled";
          break;
      }
    }
  }

  getProfileStatus(id) {
    if (!this.profileStatuses) {
      return false;
    }
    return this.profileStatuses.find(el => el.id == id)
  }  

  getPartner(id) {
    if (!this.partners) {
      return false;
    }
    return this.partners.find(el => el.partner_company_id == id)
  }  

  getValueById(id) {
    if (!this.allValues || this.allValues.length == 0) {
      return null
    }
    
    return this.filter.get('is_original') && !!this.filter.get('is_original').value ? this.allValues.find(x => x.original_id == id) : this.allValues.find(x => x.id == id)
  }
    
  getProfile(id) {
    if (!this.profiles) {
      return false;
    }
    return this.profiles.find(el => el.id == id)
  } 

  getColumnName(id) {
    if (!this.jobTypes || this.jobTypes.filter(el => el.id == id).length == 0) {
      return '';
    }
    return this.jobTypes.find(el => el.id == id)?.translation?.name ? this.jobTypes.find(el => el.id == id).translation.name : this.jobTypes.find(el => el.id == id).name
  }

  getContentById(id) {
    if (!this.allContentTypes || this.allContentTypes.filter(el => el.id == id).length == 0) {
      return false;
    }
    return this.allContentTypes.find(el => el.id == id)
  }

  getPlatformById(id) {
    if (!this.platforms || this.platforms.filter(el => el.id == id).length == 0) {
      return false;
    }
    return this.platforms.find(el => el.id == id)
  }

  getEmployee(id) {
    if (!this.employees) {
      return false;
    }
    return this.employees.find(el => el.id == id)
  }  

  getPriority(id) {
    if (!this.prioritys) {
      return false;
    }
    return this.prioritys.find(el => el.id == id)
  } 

  getLangData() {
    this.attachSubscriptions(
      this.languageService.getLangData().pipe(
        tap(resp => {
          this.activeLang = resp.active;
          this._adapter.setLocale(resp.active);
          this.currMonthName = moment().format('MMMM');
        }),
      ).subscribe(resp => {
        console.log("getLangData", resp)
      })
    )
  }

  log() {
    console.log('ActiveFiltersComponent log filter', this.filter)
    console.log('ActiveFiltersComponent log filterValue', this.filterValue)
    console.log('ActiveFiltersComponent log groups', this.groups)
  }

  getTaskStatusById(id) {
    if (!this.taskStatuses || this.taskStatuses.filter(el => el.id == id).length == 0) {
      return false;
    }
    return this.taskStatuses.find(el => el.id == id)
  }

  selectChangeSingleChange(e, key, old_id) {
    let arr = [...this.filter.value[key]]
    if (old_id == e.option.value) {
      arr.splice(arr.indexOf(old_id), 1)
    } else if (arr.includes(e.option.value)) {
      arr.splice(arr.indexOf(old_id), 1)
    } else {
      arr.splice(arr.indexOf(old_id), 1, e.option.value)
    }
    let currentParams = { ...this.activatedRoute.snapshot.queryParams };
    currentParams[key] = arr.join(',');
    this.router.navigate([], { queryParams: currentParams });
    this.closeFil();
  }

  selectChange(e, no_search?, control?) {
    console.log("selectChange", e)
    console.log("selectChange", e.option.value)

    if (control && control == 'task_operation_operation_id') {
      console.log("test1 this.filter.value.task_operation_operation_id", this.filter.value.task_operation_operation_id)
      console.log("test1 this.filter.value.no_operation_id", this.filter.value.no_operation_id)
      console.log("test1 e.option.value", e.option.value)
      if (this.filter.value.no_operation_id == e.option.value) {
        this.filter.patchValue({
          no_operation_id: ''
        })
      }
    }

    if (control && control == 'no_operation_id') {
      console.log("test2 e.option.value", e.option.value)
      console.log("test2 this.filter.value.task_operation_operation_id", this.filter.value.task_operation_operation_id)
      if (this.filter.value.task_operation_operation_id == e.option.value) {
        this.filter.patchValue({
          task_operation_operation_id: ''
        })
      } else if (!!this.filter.value.task_operation_operation_id && this.filter.value.task_operation_operation_id.length && this.filter.value.task_operation_operation_id.includes(e.option.value)) {
        let arr = [...this.filter.value.task_operation_operation_id]
        arr.splice(arr.indexOf(e.option.value), 1)
        this.filter.patchValue({
          task_operation_operation_id: arr
        })
      }
      
    }

    if (!no_search) {
      let currentParams = { ...this.activatedRoute.snapshot.queryParams };
      currentParams[this.key] = e.option.value;

      if (!!control) {
        if (control == 'no_operation_id') {
          currentParams['task_operation_operation_id'] = this.filter.value.task_operation_operation_id && this.filter.value.task_operation_operation_id.length ? this.filter.value.task_operation_operation_id.join(',') : this.filter.value.task_operation_operation_id;
        }
        if (control == 'task_operation_operation_id') {
          currentParams['no_operation_id'] = this.filter.value.no_operation_id;
        }
      }

      console.log("currentParams", currentParams)

      this.router.navigate([], { queryParams: currentParams });
      this.closeFil();
    }
  }

  // changeUrl() {
  //   // Получаем текущие параметры
  //   const currentParams = { ...this.activatedRoute.snapshot.queryParams };
  
  //   // Меняем параметр `channel_platform_id`
  //   currentParams['channel_platform_id'] = 2;
    
  //   // Навигируем с обновленными параметрами
  //   this.router.navigate([], { queryParams: currentParams });
  // }

  onSearchFilter(resp, key) {
    switch (key) {
      case 'channel_platform_id':
        if (!this.platforms) {
          return;
        }
    
        if (!resp) {
          this.platforms$.next(this.platforms.slice());
          return;
        } else {
          resp = resp.toLowerCase();
        }
    
        // filter the banks
        this.platforms$.next(
          this.platforms.filter(b => b.name.toLowerCase().indexOf(resp) > -1)
        );
        break;
      case 'content_type_id':
        if (!this.contentTypes) {
          return;
        }
    
        const contentTypesCopy = this.copyContentTypesGroups(this.contentTypes);
        if (!resp) {
          this.contentTypes$.next(contentTypesCopy);
          return;
        } else {
          resp = resp.toLowerCase();
        }
        // filter the banks
        // this.contentTypes$.next(
        //   this.contentTypes.filter(z => (z.name.toLowerCase().indexOf(resp) > -1))
        // );
    
        // filter the banks
        this.contentTypes$.next(
          contentTypesCopy.filter(type => {
            type.types = type.types.filter(t => t.name.toLowerCase().indexOf(resp) > -1);
            return type.types.length > 0;
          })
        );
    
        this.contentTypes$.asObservable().subscribe(res => {
          console.log("search", res)
          console.log(this.contentTypes)
        });
      case 'no_operation_id':
        if (!this.jobTypes) {
          return;
        }
    
        if (!resp) {
          this.jobTypes$.next(this.jobTypes.slice());
          return;
        } else {
          resp = resp.toLowerCase();
        }
    
        // filter the banks
        this.jobTypes$.next(
          this.jobTypes.filter(b => b.name.toLowerCase().indexOf(resp) > -1)
        );
        break;
      case 'task_operation_operation_id':
        if (!this.jobTypes) {
          return;
        }
    
        if (!resp) {
          this.jobTypes$.next(this.jobTypes.slice());
          return;
        } else {
          resp = resp.toLowerCase();
        }
    
        // filter the banks
        this.jobTypes$.next(
          this.jobTypes.filter(b => b.name.toLowerCase().indexOf(resp) > -1)
        );
        break;
      case 'discussion_channel_id':
        if (!this.profiles) {
          return;
        }
    
        if (!resp) {
          this.profiles$.next(this.profiles.slice());
          return;
        } else {
          resp = resp.toLowerCase();
        }
    
        // filter the banks
        this.profiles$.next(
          this.profiles.filter(b => b.name.toLowerCase().indexOf(resp) > -1)
        );
        break;
      case 'no_channel_id':
        if (!this.profiles) {
          return;
        }
    
        if (!resp) {
          this.profiles$.next(this.profiles.slice());
          return;
        } else {
          resp = resp.toLowerCase();
        }
    
        // filter the banks
        this.profiles$.next(
          this.profiles.filter(b => b.name.toLowerCase().indexOf(resp) > -1)
        );
        break;
      case 'channel_id':
        if (!this.profiles) {
          return;
        }
    
        if (!resp) {
          this.profiles$.next(this.profiles.slice());
          return;
        } else {
          resp = resp.toLowerCase();
        }
    
        // filter the banks
        this.profiles$.next(
          this.profiles.filter(b => b.name.toLowerCase().indexOf(resp) > -1)
        );
        break;
      case 'task_status_id':
        if (!this.taskStatuses) {
          return;
        }
    
        if (!resp) {
          this.taskStatuses$.next(this.taskStatuses.slice());
          return;
        } else {
          resp = resp.toLowerCase();
        }
    
        // filter the banks
        this.taskStatuses$.next(
          this.taskStatuses.filter(b => b.name.toLowerCase().indexOf(resp) > -1)
        );
        break;
      case 'group_id':
        if (!this.activatedRoute.snapshot.queryParamMap.get('groups_partner_id')) {
          if (!this.groups) {
            return;
          }
      
          if (!resp) {
            this.groups$.next(this.groups.slice());
            return;
          } else {
            resp = resp.toLowerCase();
          }
      
          // filter the banks
          this.groups$.next(
            this.groups.filter(b => b.name.toLowerCase().indexOf(resp) > -1)
          );
        } else {
          if (!this.partnerGroups) {
            return;
          }
      
          if (!resp) {
            this.partnerGroups$.next(this.partnerGroups.slice());
            return;
          } else {
            resp = resp.toLowerCase();
          }
      
          // filter the banks
          this.partnerGroups$.next(
            this.partnerGroups.filter(b => b.name.toLowerCase().indexOf(resp) > -1)
          );
        }

        break;
      case 'operation_employee_id':
        if (!this.employees) {
          return;
        }
    
        if (!resp) {
          this.employees$.next(this.employees.slice());
          return;
        } else {
          resp = resp.toLowerCase();
        }
    
        // filter the banks
        this.employees$.next(
          this.employees.filter(b => b.name.toLowerCase().indexOf(resp) > -1)
        );
        break;
      case 'parameter_value_id':
        this.filterAllValues(resp)
        break;
      case 'task_parameter_value_id':
        this.filterAllValues(resp)
        break;
      case 'task_operation_parameter_value_id':
        this.filterAllValues(resp)
        break;
      case 'discussion_parameter_value_id':
        this.filterAllValues(resp)
        break;
      case 'file_parameter_value_id':
        this.filterAllValues(resp)
        break;
      case 'operation_partner_company_id':
        if (!this.partners) {
          return;
        }

        if (!resp) {
          this.partners$.next(this.partners.slice());
          return;
        } else {
          resp = resp.toLowerCase();
        }
        // filter the banks
        this.partners$.next(
          this.partners.filter(z => z.partnerCompany.name.toLowerCase().indexOf(resp) > -1)
        );
        break;
      case 'client_employee_id':
        if (!this.employees) {
          return;
        }
    
        if (!resp) {
          this.employees$.next(this.employees.slice());
          return;
        } else {
          resp = resp.toLowerCase();
        }
    
        // filter the banks
        this.employees$.next(
          this.employees.filter(b => b.name.toLowerCase().indexOf(resp) > -1)
        );
        break;
    
      default:
        break;
    }
  }

  minDate(key) {
    if (key.indexOf('_from') != -1) {
      return null
    }

    return this.filter.get(key.replace('_to', '_from')).value
  }

  maxDate(key) {
    if (key.indexOf('_to') != -1) {
      return null
    }
    
    return this.filter.get(key.replace('_from', '_to')).value
  }

  addEvent(event: MatDatepickerInputEvent<Date>, key) {
    console.log("event,key", event, key)

    let currentParams = { ...this.activatedRoute.snapshot.queryParams };
    this.filter.patchValue({
      [key]: event,
    })
    currentParams[key] = this.filter.value[key].format("X")

    console.log("currentParams", currentParams)
    this.router.navigate([], { queryParams: currentParams });
    this.closeFil();
  }
  
  protected copyContentTypesGroups(contentTypes: any) {
    const contentTypesCopy = [];
    contentTypes.forEach(type => {
      contentTypesCopy.push({
        channel_platform_id: type.channel_platform_id,
        types: type.types.slice()
      });
    });
    return contentTypesCopy;
  }

  filterAllValues(resp) {
    if (!this.allValues) {
      return;
    }

    if (!resp) {
      this.allValues$.next(this.allValues.slice());
      return;
    } else {
      resp = resp.toLowerCase();
    }

    // filter the banks
    this.allValues$.next(
      this.allValues.filter(b => b.value.toLowerCase().indexOf(resp) > -1)
    );
  }

  openFilter(e, el, key, id?) {
    // return
    e.preventDefault();
    e.stopPropagation();

    this.closeFil();
    this.key = key;
    let x = el.offsetLeft;
    let y =  el.offsetTop + el.offsetHeight;
    const positionStrategy = this.overlay.position()
      .flexibleConnectedTo({ x, y })
      .withPositions([
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top',
        }
      ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.close()
    });

    this.overlayRef.attach(new TemplatePortal(this.filMenu, this.viewContainerRef, {
      $implicit: {
        key: key,
        id: id,
        isCalendar: key.indexOf("_from") != 1 || key.indexOf("_to") != 1,
        hasSearch: ['channel_platform_id', 'content_type_id', 'channel_id', 'discussion_channel_id', 'no_channel_id', 'task_operation_operation_id', 'no_operation_id', 'parameter_value_id', 'task_parameter_value_id', 'task_operation_parameter_value_id', 'discussion_parameter_value_id', 'file_parameter_value_id', 'group_id', 'client_employee_id', 'operation_partner_company_id', 'operation_employee_id', 'task_status_id'].includes(key)
      }
    }));
    
    this.sub = fromEvent<MouseEvent>(document, 'click')
      .pipe(
        filter(event => {
          const clickTarget = event.target as HTMLElement;
          // mat-calendar
          // console.log("clickTarget", clickTarget)
          // console.log("!!this.overlayRef", !!this.overlayRef)
          // console.log("this.overlayRef.overlayElement", this.overlayRef.overlayElement)
          // console.log("this.overlayRef.overlayElement", !clickTarget.closest('.mat-calendar'))
          // console.log("!this.overlayRef.overlayElement.contains(clickTarget);", !this.overlayRef.overlayElement.contains(clickTarget))
          // console.log("!!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);", !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget))
          // return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget) && !clickTarget.closest('.mat-calendar');
          let check1 = !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget)
          let check5 = !clickTarget.classList.contains('mat-calendar-body-cell-content')
          return check1 && check5
        }),
        take(1)
      ).subscribe(() => this.closeFil())

  }

  closeFil() {
    console.log("closeFil")
    this.key = '';
    this.searchFil.patchValue('');
    this.sub && this.sub.unsubscribe();
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }

  removeValue(val) {
    this.RemoveValue.emit(val)
  }
  
  removeValueFromMultiple(key, id) {
    this.RemoveValueFromMultiple.emit({key: key, id: id})
  }

  ngOnDestroy(): void {
    this.clearSubscriptions()
  }

}
